import {
  AssignedProducts,
  WarehouseLocality,
  WarehouseLocalityStatus,
  WarehouseSynchronizationResult,
} from './warehouseApiTypes';

export const mockWarehouseLocalities: WarehouseLocality[] = [
  {
    id: 1,
    code: '0001',
    name: 'Warehouse 1',
    city: 'Prague',
    countryCode: 'CZ',
    street: 'Street 1',
    houseNumber: '1',
    postcode: '123456',
    company: 'Joe Doe Company',
    phone: '+420123456789',
    expeditionShiftByDPlus: 1,
    maxHandlingTime: 1,
    isDefault: false,
    isFullImportRunning: false,
    lastFullImport: '2023-11-23T11:14:54.919Z',
    lastFullImportProducts: 10,
    fullImportFailedMessage: 'productList[0].code missing',
    status: WarehouseLocalityStatus.SYNCHRONIZED,
  },
  {
    id: 2,
    code: '0002',
    name: 'Warehouse 2',
    city: 'Brno',
    countryCode: 'CZ',
    street: 'Street 2',
    houseNumber: '2',
    postcode: '234567',
    company: 'Jane Doe Company',
    email: 'janedoe@email.com',
    phone: '+420987654321',
    expeditionShiftByDPlus: 2,
    maxHandlingTime: 2,
    isDefault: true,
    isFullImportRunning: false,
    lastFullImport: '2023-11-23T11:14:54.919Z',
    lastFullImportProducts: 50,
    lastFullImportProductCodes: '01\n02',
    status: WarehouseLocalityStatus.NOT_SYNCHRONIZED,
  },
  {
    id: 3,
    code: '0003',
    city: 'Lodz',
    countryCode: 'PL',
    province: 'LODZKIE',
    street: 'Street 3',
    isDefault: false,
    isFullImportRunning: false,
    lastFullImport: '2023-11-23T11:14:54.919Z',
    lastFullImportProducts: 100,
    status: WarehouseLocalityStatus.NOT_ON_MARKETPLACE,
  },
  {
    id: 5,
    name: 'Warehouse 5',
    city: 'Hradec Kralove',
    countryCode: 'CZ',
    street: 'Street 5',
    houseNumber: '5',
    postcode: '500002',
    phone: '+420555666777',
    isDefault: false,
    isFullImportRunning: false,
    status: WarehouseLocalityStatus.NOT_ON_MARKETPLACE,
  },
  {
    code: '0004',
    name: 'Warehouse 4',
    city: 'Plzen',
    countryCode: 'CZ',
    street: 'Street 4',
    houseNumber: '4',
    postcode: '654321',
    isDefault: false,
    status: WarehouseLocalityStatus.NOT_IMPORTED,
  },
];

export const mockWarehouseSynchronizationResult: WarehouseSynchronizationResult = {
  savedWarehouseLocalities: [
    {
      id: 1,
      code: '0001',
      city: 'Prague',
      countryCode: 'CZ',
      street: 'Street 1',
      isDefault: false,
      isFullImportRunning: false,
      status: WarehouseLocalityStatus.SYNCHRONIZED,
    },
    {
      id: 2,
      code: '0002',
      city: 'Brno',
      countryCode: 'CZ',
      street: 'Street 2',
      isDefault: true,
      isFullImportRunning: false,
      status: WarehouseLocalityStatus.SYNCHRONIZED,
    },
  ],
  notDeletedWarehouseLocalities: [
    {
      warehouseLocality: {
        id: 3,
        code: '0003',
        city: 'Ostrava',
        countryCode: 'CZ',
        street: 'Street 3',
        isDefault: true,
        isFullImportRunning: false,
        status: WarehouseLocalityStatus.NOT_ON_MARKETPLACE,
      },
      numberOfAssignedProducts: 15,
    },
  ],
};

export const mockGetWarehouseLocality: WarehouseLocality = {
  id: 1,
  code: '0001',
  city: 'Prague',
  countryCode: 'PL',
  street: 'Street 1',
  houseNumber: '1',
  postcode: '123456',
  company: 'Joe Doe Company',
  province: 'LODZKIE',
  name: 'Joe Doe',
  maxHandlingTime: 1,
  expeditionShiftByDPlus: 1,
  email: 'joedoe@email.com',
  phone: '+123456789',
  isDefault: false,
  isFullImportRunning: false,
};

export const mockGetAssignedProducts: AssignedProducts[] = [
  { warehouseLocalityId: 1, numberOfProducts: 1000 },
  { warehouseLocalityId: 2, numberOfProducts: 2000 },
  { warehouseLocalityId: 3, numberOfProducts: 3000 },
];
